import React from "react";
import PropTypes from "prop-types";

import { FormControl, InputLabel, MenuItem, Select, } from "@mui/material";

import { socialTypes } from "utils/pageElements/constants";

const SocialSelector = ({ elementType, onChange, disabled }) => {

  return (
      <FormControl fullWidth >
        <InputLabel color="warning" size="small">Network</InputLabel>
        <Select
          label="Network"
          color="warning"
          name="element_type"
          size="small"
          value={elementType === "social" ? null : elementType}
          onChange={onChange}
          disabled={disabled}
        >

          {socialTypes.map((type, index) => (
            <MenuItem key={index} value={type.value}>
              {type.title}
            </MenuItem>
          ))}

        </Select>

      </FormControl>
  );
};

SocialSelector.propTypes = {
  elementType: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SocialSelector;
